export default function BlueprintBackground() {
  return (
    <div className="fixed inset-0 pointer-events-none opacity-[0.03] overflow-hidden z-0">
      <div
        className="absolute inset-0"
        style={{
          backgroundImage: "radial-gradient(var(--mint-text) 1px, transparent 1px)",
          backgroundSize: "40px 40px",
        }}
      />
      <div
        className="absolute inset-0"
        style={{
          backgroundImage:
            "linear-gradient(to right, var(--mint-text) 1px, transparent 1px), linear-gradient(to bottom, var(--mint-text) 1px, transparent 1px)",
          backgroundSize: "200px 200px",
        }}
      />
    </div>
  );
}
